import { createActionCreator } from 'utils';

const { createAction } = createActionCreator('UI');

export const setUi = createAction('Set UI', (name, value) => ({ name, value }));

export const setTrue = (name) => () => setUi(name, true);

export const setFalse = (name) => () => setUi(name, false);
